import { ROLES } from 'helper/const';
import { adminPermission } from './admin';
import { clientPermission } from './client';

const permissions = {
  [ROLES.SUPER_ADMIN]: adminPermission,
  [ROLES.ADMIN]: adminPermission,
};

const getPermission = (role = ROLES.CLIENT, currentUser = {}) => {
  return (
    permissions[role] ||
    (!!currentUser.group_id ? adminPermission : clientPermission)
  );
};

export default getPermission;
